export default {
  props: {
    skin: String,
    rows: Array,
  },
  created() {},
};
